"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ArchiveImageCard = props => {
  const {
    imageId,
    imageUrl
  } = props;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "con-speaker-card",
    id: "archive-image-".concat(imageId)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-archive-card__inner"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-archive__container",
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    }
  })));
};
ArchiveImageCard.propTypes = {
  imageId: _propTypes.default.string,
  imageUrl: _propTypes.default.string
};
var _default = exports.default = ArchiveImageCard;